import React, { useEffect, useState } from "react";
import { Handle, Position } from "reactflow";

import { useFlowNodes } from "../../../../../context";
import { ButtonDelete } from "../../../../ButtonDelete";
// Styles
import "components/Accordion/styles/styles.scss";
// Components
import { Divider } from "@material-ui/core";
import {
  Button,
  Input,
  SelectAutocomplete,
  SelectSimple,
} from "@components/Input";
import Tooltip from "@components/Tooltip";
import { returnElementFromArray } from "vendor/application";
// SVG
import { closeSvg, deleteSvg } from "assets";
import { getSuncoCustomFields } from "views/Bots/NLP/application/Build/Flow/services/getCustomerFields";
import { typesNodes } from "../../../../../types/nodeTypes/typesNodes";

import "./VariablesFlow.scss";

export const VariablesFlow = (props) => {
  const {
    intent,
    use_custom_fields,
    integrations,
    updateIntent,
    access,
    actualProject,
    limitsIntegrations,
    dispatch,
    handleTabs,
    history,
    i18n,
    location,
    t,
    tReady,
    setUseCustomFields,
    updateVariables,
    variables,
    setNodes,
    setEdges,
    type,
    getCustomFieldsCreate,
    getCustomFields,
    deleteVariable,
  } = useFlowNodes();
  const id = props.id;
  const i = props.data?.dataInfo?.indexParam || 0;
  const el = variables[i];

  const [extensionsSelected, setExtensionsSelected] = useState([]);

  useEffect(() => {
    try {
      getSuncoCustomFields({
        intent,
        use_custom_fields,
        integrations,
        i,
        updateIntent,
        access,
        actualProject,
        limitsIntegrations,
        dispatch,
        handleTabs,
        history,
        i18n,
        location,
        t,
        tReady,
        setUseCustomFields,
        getCustomFields 
      });
    } catch (error) {
      console.log(error);
    }
  }, []);

  if (!el) {
    return null;
  }
  function integrationSunco() {
    if (!integrations) {
      return null;
    }
    return integrations?.find((int) => int.channel === "sunco");
  }

  function integrationZendesk() {
    if (!integrations) {
      return null;
    }
    return integrations?.find((int) => int.channel === "zendesk_full");
  }
  const getDeskIdZendesk = () => {
    const integration_zendesk = integrationZendesk();
    const zendeskId = integration_zendesk?.channel_id;
    return zendeskId;
  };

  function getDeskId() {
    const integration_sunco = integrationSunco();
    const suncoId = integration_sunco?.channel_id;

    return suncoId;
  }

  const updateVariable = (e, type, i) => {
    if (type === "variable") {
      const oldName = "$." + variables[i].variable;
      const newName = "$." + e.target.value;

      const entry =
        intent.extensions.variables_desk &&
        intent.extensions.variables_desk.find((v) => v.name === oldName);
      if (entry) entry.name = newName;

      variables[i].variable = e.target.value;

      updateIntent(intent);
      updateVariables(variables);
    }
  };

  const updateEquivalence = (e, variable_pos, equivalence_pos, type) => {
    variables[variable_pos].equivalence[equivalence_pos][type] = e.target.value;
    updateVariables(variables);
    updateIntent(intent);
  };

  const addEquivalence = (e, i) => {
    variables[i].equivalence.push([{ key: "", value: "" }]);
    updateVariables(variables);
  };

  const deleteEquivalence = (e, variable_pos, equivalence_pos) => {
    variables[variable_pos].equivalence.splice(equivalence_pos, 1);
    updateVariables(variables);
    updateIntent(intent);
  };

  const deleteTicketField = (i) => {
    const newVariables = [...variables];
    intent.extensions.variables_desk[i].zendesk_ticket_field = null;
    newVariables[i].zendesk_ticket_field = null;
    updateVariables(newVariables);
    updateIntent(intent);
  };

  const handleParameters = (e, type, i) => {
    const variable = variables[i];

    const newVariables = [...variables];
    const desk_id = variable?.zendesk_ticket_field?.desk_id;
    newVariables[i].zendesk_ticket_field = {
      id: e.id,
      type: e.type,
      title: e.title,
      equivalences: [],
      desk_id,
      custom_field_options: e.custom_field_options ?? [],
      custom_field_options_actual: e.custom_field_options
        ? JSON.parse(JSON.stringify(e.custom_field_options))
        : [],
    };
    updateVariables(newVariables);
  };

  const handleExtensions = (e, type, i, deskIdProps) => {
    const suncoIntegration = integrationSunco();
    const zendeskIntegration = integrations?.filter(
      (int) => int.channel === "zendesk_full"
    )[0];
    const validIdZendeskUnique =
      zendeskIntegration && integrations?.length === 1;
    const deskId = validIdZendeskUnique
      ? integrations[0]?.id
      : intent.extensions?.variables_desk?.[i]?.zendesk_ticket_field?.desk_id;
    const index = zendeskIntegration?.multiple?.findIndex(
      (desk) => desk.id === deskId
    );
    const newValueDeskId = deskIdProps.zendesk_ticket_field?.desk_id || deskId;

    let desk_id = null;
    if (suncoIntegration) {
      desk_id = getDeskId();
    } else if (zendeskIntegration) {
      desk_id =
        newValueDeskId ??
        integrations?.[0]?.multiple?.[i]?.id ??
        integrations?.[0]?.multiple?.[index]?.id ??
        null;
    }

    if (!e || !desk_id) {
      return;
    }
    const options = {
      id: e.id,
      type: e.type,
      title: e.title,
      equivalences: [],
      desk_id,
      custom_field_options: e.custom_field_options ?? [],
      custom_field_options_actual: e.custom_field_options
        ? JSON.parse(JSON.stringify(e.custom_field_options))
        : [],
    };

    const variable = variables[i];
    variable.zendesk_ticket_field = options;

    const { variables_desk } = intent.extensions;

    /**
     * @type {Map<string, import('types/zendesk').ZendeskVariable>}
     */
    const ticketFieldByVariableName = new Map(
      (variables_desk || [])
        .filter((variable_desk) => !!variable_desk)
        .map((variable_desk) => [variable_desk.name, variable_desk])
    );

    const name = "$." + variable.variable;

    ticketFieldByVariableName.set(name, {
      name,
      zendesk_ticket_field: options,
    });

    intent.extensions.variables_desk = Array.from(
      ticketFieldByVariableName.values()
    );

    updateIntent(intent);
    updateVariables(variables);
  };

  const addParameterEquivalence = (i) => {
    if (!variables[i].zendesk_ticket_field.equivalences) {
      variables[i].zendesk_ticket_field.equivalences = [];
    }
    variables[i].zendesk_ticket_field.equivalences.push({
      text: "",
      value: "",
      title: "",
    });
    if (
      intent.extensions.variables_desk?.[i] &&
      !intent.extensions.variables_desk[i].zendesk_ticket_field
    ) {
      intent.extensions.variables_desk[i].zendesk_ticket_field = {};
    }
    intent.extensions.variables_desk = intent.extensions.variables_desk || [];
    if (!intent.extensions.variables_desk[i]) {
      intent.extensions.variables_desk[i] = { zendesk_ticket_field: {} };
    }
    intent.extensions.variables_desk[i].zendesk_ticket_field.equivalences = [
      ...variables[i].zendesk_ticket_field.equivalences,
    ];

    updateIntent(intent);
    updateVariables(variables);
  };

  const updateParameterEquivalence = (e, variable, equivalence) => {
    if (variables[variable].zendesk_ticket_field.equivalences[equivalence]) {
      variables[variable].zendesk_ticket_field.equivalences[equivalence].text =
        e.target.value;
    }
    updateVariables(variables);
  };

  /**
   * @param {{ name: string; value: number }} e
   * @param {{
   *  equivalenceIndex: number;
   *  variableIndex: number;
   * }} indexes
   */

  const getZendeskTicketFieldByVariableName = (variableName) => {
    return (
      intent.extensions?.variables_desk?.find(
        (v) => v.name === `$.${variableName}`
      )?.zendesk_ticket_field || null
    );
  };

  const selectParameterEquivalence = (e, indexes) => {
    const { variableIndex, equivalenceIndex } = indexes;

    const variable = variables[variableIndex];
    const ticketField = variable.zendesk_ticket_field;
    if (!ticketField) return;

    const equivalences =
      ticketField.equivalences?.length > 0 ? ticketField.equivalences : [];

    const all_custom_field =
      ticketField.custom_field_options?.length > 0
        ? [...ticketField.custom_field_options]
        : [
            ...(getDeskFieldByVariable(variable.variable)
              ?.custom_field_options || []),
          ];

    let actual_custom_field =
      ticketField.custom_field_options_actual?.length > 0
        ? [...ticketField.custom_field_options_actual]
        : [
            ...(getDeskFieldByVariable(variable.variable)
              ?.custom_field_options_actual || []),
          ];

    const usedOptions = equivalences.map((eq) => eq.value).filter(Boolean);
    const allValues = all_custom_field.map((opt) => opt.value);

    if (usedOptions.includes(e.value)) return;

    if (usedOptions.length >= allValues.length) return;

    const currentEquivalence = equivalences[equivalenceIndex];
    if (currentEquivalence?.value && currentEquivalence.value !== e.value) {
      const prevOption = returnElementFromArray(
        currentEquivalence.value,
        all_custom_field,
        "value"
      );
      if (
        prevOption &&
        !actual_custom_field.some((opt) => opt.value === prevOption.value)
      ) {
        actual_custom_field.push(prevOption);
      }
    }
    actual_custom_field = actual_custom_field.filter(
      (opt) => opt.value !== e.value
    );
    if (!currentEquivalence) {
      return;
    }

    currentEquivalence.value = e?.value;
    currentEquivalence.title = e?.name;
    const uniqueOptions = actual_custom_field.filter(
      (opt, idx, self) => self.findIndex((o) => o.value === opt.value) === idx
    );

    ticketField.custom_field_options_actual = uniqueOptions;
    variable.zendesk_ticket_field = ticketField;
    variables[variableIndex] = variable;

    updateVariables([...variables]);
  };

  const deleteParameterEquivalence = (variable, equivalence) => {
    const variableObj = variables?.[variable];

    if (!variableObj?.zendesk_ticket_field) return;

    const ticketField = variableObj.zendesk_ticket_field;

    const equivalences =
      ticketField.equivalences?.length > 0 ? ticketField.equivalences : [];

    const all_custom_field =
      ticketField.custom_field_options?.length > 0 &&
      ticketField.custom_field_options.length > 0
        ? ticketField.custom_field_options
        : Array.isArray(
            getDeskFieldByVariable(variableObj.variable)?.custom_field_options
          )
        ? getDeskFieldByVariable(variableObj.variable).custom_field_options
        : [];

    const actual_custom_field =
      ticketField.custom_field_options_actual?.length > 0 &&
      ticketField.custom_field_options_actual.length > 0
        ? ticketField.custom_field_options_actual
        : Array.isArray(
            getDeskFieldByVariable(variableObj.variable)
              ?.custom_field_options_actual
          )
        ? getDeskFieldByVariable(variableObj.variable)
            .custom_field_options_actual
        : [];
    if (equivalences?.[equivalence]?.value) {
      const element = returnElementFromArray(
        equivalences[equivalence].value,
        all_custom_field,
        "value"
      );

      if (
        element &&
        !actual_custom_field.find((el) => el.value === element.value)
      ) {
        actual_custom_field.push(element);
      }
    }

    if (equivalences.length > equivalence) {
      equivalences.splice(equivalence, 1);
    }
    if (Array.isArray(extensionsSelected)) {
      extensionsSelected.splice(equivalence, 1);
      setExtensionsSelected(extensionsSelected);
    }

    ticketField.equivalences = equivalences;
    ticketField.custom_field_options_actual = actual_custom_field;
    variableObj.zendesk_ticket_field = ticketField;
    variables[variable] = variableObj;

    updateVariables([...variables]);
    const name = "$." + variableObj.variable;
    const variablesDeskMap = new Map(
      (intent?.extensions?.variables_desk || [])
        .filter((v) => !!v)
        .map((v) => [v.name, v])
    );

    variablesDeskMap.set(name, {
      name,
      zendesk_ticket_field: ticketField,
    });
    intent.extensions.variables_desk = Array.from(variablesDeskMap.values());
    updateIntent(intent);
  };

  const handleSelector = () => {
    if (integrations.length > 0) {
      const integration = integrations.find(
        (int) => int.channel === "zendesk_full"
      );

      if (!integration) return false;

      const use_custom = integration?.multiple.filter(
        (int) => int.use_custom_fields
      );
      if (!use_custom) return false;

      if (use_custom?.length === 1) {
        return true;
      }
      if (use_custom?.length > 1) {
        return true;
      }
    }
    return false;
  };
  const updateDeskId = (deskId, i, elId) => {
    const newVariables = [...variables];
    if (!newVariables[i].zendesk_ticket_field) {
      newVariables[i].zendesk_ticket_field = {};
    }
    newVariables[i].zendesk_ticket_field = {
      desk_id: deskId,
      id: null,
      type: "",
      title: "",
      equivalences: [],
      custom_field_options: [],
      custom_field_options_actual: [],
    };

    const name = "$." + newVariables[i].variable;
    const variablesDeskMap = new Map(
      (intent?.extensions?.variables_desk || [])
        .filter((v) => !!v)
        .map((v) => [v.name, v])
    );
    const newZendeskTicketField = {
      ...newVariables[i].zendesk_ticket_field,
      id: elId,
      type: type,
      title: intent.name,
      equivalences: [],
      desk_id: deskId,
    };
    setExtensionsSelected([
      newZendeskTicketField,
      ...(extensionsSelected || []),
    ]);
    variablesDeskMap.set(name, {
      name,
      zendesk_ticket_field: newZendeskTicketField,
    });

    intent.extensions.variables_desk = Array.from(variablesDeskMap.values());

    updateVariables(newVariables);
    updateIntent(intent);

    if (!use_custom_fields || !use_custom_fields[deskId]) {
      getCustomFieldsCreate("zendesk", deskId);
    }
  };

  const getDeskFieldByVariable = (variableName) => {
    return intent?.extensions?.variables_desk?.find(
      (v) => v.name === `$.${variableName}`
    )?.zendesk_ticket_field;
  };

  const integration = integrations.find(
    (int) => int.channel === "zendesk_full"
  );
  const validSuncoIntegration = integrationSunco();
  const suncoDeskId = validSuncoIntegration ? getDeskId() : null;
  const validZendeskIntegration = integrationZendesk();
  const zendeskDeskId = validZendeskIntegration ? getDeskIdZendesk() : null;

  const desk_id = integration
    ? el?.zendesk_ticket_field?.desk_id ?? null
    : suncoDeskId ?? null;

  let zendesk_options = [];

  if (desk_id && use_custom_fields?.[desk_id]) {
    const deskOptions = use_custom_fields[desk_id] || [];

    if (deskOptions.length > 0) {
      zendesk_options = deskOptions;
    } else if (typeof deskOptions === "object") {
      zendesk_options =
        Object.values(deskOptions).find((val) => Array.isArray(val)) || [];
    }
  }
  const has_zendesk = zendesk_options?.length > 0;

  // const integrationExists = integrations?.some((int) =>
  //   int?.multiple?.some(
  //     (d) => d.id === el?.zendesk_ticket_field?.desk_id
  //   )
  // );

  const zendesk_options_title_map = zendesk_options.map((option) => ({
    ...option,
    title: `${option.title} ${
      option.regexp_for_validation ? `(${option.regexp_for_validation})` : ""
    }`,
  }));
  const zendesk_ticket_field = el?.zendesk_ticket_field ?? {};
  const showZendeskTicketField =
    zendesk_ticket_field?.type === "tagger" &&
    (zendesk_ticket_field?.custom_field_options?.length > 0 ||
      zendesk_ticket_field?.custom_field_options_actual?.length > 0 ||
      true);

  var desk_name = "-";
  if (el.zendesk_ticket_field && el.zendesk_ticket_field.desk_id) {
    desk_name = integration?.multiple?.filter(
      (int) => int.id === el.zendesk_ticket_field.desk_id
    )[0]?.name;
  }

  const deskId = zendesk_ticket_field?.desk_id ?? null;
  const allOptions =
    Array.isArray(zendesk_ticket_field.custom_field_options) &&
    zendesk_ticket_field.custom_field_options.length > 0
      ? zendesk_ticket_field.custom_field_options
      : getDeskFieldByVariable(el.variable)?.custom_field_options?.length > 0
      ? getDeskFieldByVariable(el.variable).custom_field_options
      : use_custom_fields?.[deskId]
      ? intent?.extensions?.variables_desk?.[0]?.zendesk_ticket_field
          ?.custom_field_options ?? []
      : [];

  const currentEquivalences = el.zendesk_ticket_field?.equivalences || [];
  const options = allOptions || [];

  const isMaxReached = currentEquivalences.length >= options.length;

  const selectedOption = (() => {
    const validOptions = zendesk_options_title_map;
    const currentId = el?.zendesk_ticket_field?.id;

    const isValid = validOptions.some((opt) => opt.id === currentId);
    return isValid ? validOptions.find((opt) => opt.id === currentId) : null;
  })();
  const handleDelete = () => {
    deleteVariable(i);
    setNodes((prevNodes) => {
      const variablesNodes = prevNodes.filter(
        (node) => node.type === typesNodes.extensionsVariablesFlow
      );
      return prevNodes.map((node) => {
        if (
          variablesNodes.includes(node) &&
          node.data?.dataInfo?.indexParam > i
        ) {
          node.data.dataInfo.indexParam -= 1;
        }
        return node;
      });
    });
  };
  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="variables-config-container">
        <div className="variables-delete-container">
          <ButtonDelete
            handleDelete={handleDelete}
            setNodes={setNodes}
            setEdges={setEdges}
            nodeId={id}
          />
        </div>
        <div className={"accordion__element_variables"}>
          <div className={"accordion__element_header"}>
            <span>
              {t("intents.config.accordion.extensions.content.variables.title")}{" "}
              <Tooltip
                text={t(
                  "intents.config.accordion.extensions.content.variables.description"
                )}
              />
            </span>
          </div>
          <div className={"accordion__element_content"}>
            <div
              className={"accordion__element_variable"}
              key={`variable_${i}`}
            >
              <div className={"accordion__element_variable_header"}>
                <div className={"accordion__element_variable_header_content"}>
                  <span>$.</span>
                  <Input
                    type={"transparent"}
                    className={`${el.error ? "error" : ""}`}
                    placeholder={t(
                      "intents.config.accordion.extensions.content.variables.variable.name"
                    )}
                    inputProps={{ "aria-label": "description" }}
                    value={el.variable}
                    onChange={(e) => {
                      updateVariable(e, "variable", i);
                    }}
                  />
                </div>
                {/* TODO: change for DeleteButton */}
                {/* <div className={"accordion__element_variable_header_actions"}>
                  <div onClick={() => handleCopy(`$.${el.variable}`)}>
                    {copySvg()}
                  </div>
                  <div
                    onClick={(e) => {

                      deleteVariable(e, i);
                   
                    }}
                  >
                    {deleteSvg()}
                  </div>
                </div> */}
              </div>
              <div className={"accordion__element_variable_content"}>
                {el.equivalence &&
                  el.equivalence.length > 0 &&
                  el.equivalence.map((equivalence, equivalence_pos) => {
                    return (
                      <React.Fragment key={`equivalence_${equivalence_pos}`}>
                        <div
                          className={
                            "accordion__element_variable_content_equivalences"
                          }
                        >
                          <Input
                            onChange={(e) => {
                              updateEquivalence(e, i, equivalence_pos, "key");
                            }}
                            value={equivalence.key ? equivalence.key : ""}
                            placeholder={t(
                              "intents.config.accordion.extensions.content.variables.variable.key"
                            )}
                            className={"secondary"}
                            inputProps={{ maxLength: 4096 }}
                          />
                          <Input
                            onChange={(e) => {
                              updateEquivalence(e, i, equivalence_pos, "value");
                            }}
                            value={equivalence.value ? equivalence.value : ""}
                            placeholder={t(
                              "intents.config.accordion.extensions.content.variables.variable.value"
                            )}
                            className={"secondary"}
                            inputProps={{ maxLength: 4096 }}
                          />
                          <div
                            className={"platform_input_content_delete"}
                            onClick={(e) => {
                              deleteEquivalence(e, i, equivalence_pos);
                            }}
                          >
                            {deleteSvg()}
                          </div>
                        </div>
                        {equivalence_pos !== el.equivalence.length - 1 && (
                          <Divider />
                        )}
                      </React.Fragment>
                    );
                  })}
                <>
                  <Button
                    type={"dashed"}
                    onClick={(e) => {
                      addEquivalence(e, i);
                    }}
                    text={t(
                      "intents.config.accordion.extensions.content.variables.variable.add"
                    )}
                  />
                </>
                {handleSelector() && (
                  <div className={"accordion__element_use_custom_fields"}>
                    <SelectSimple
                      valueSelected={desk_name}
                      items={integration?.multiple}
                      label={t("common:intents.integrations.desk_id")}
                      onSelect={(e) => {
                        updateDeskId(e, i, el?.zendesk_ticket_field?.id);
                      }}
                      placeholder={t("common:intents.integrations.desk_id")}
                      value={"id"}
                      t={t}
                      className={"select_secondary nodrag"}
                    />
                  </div>
                )}

                {has_zendesk && (
                  <>
                    <div
                      className={"accordion__element_variable_content_custom"}
                    >
                      <div className={"accordion__element_use_custom_fields"}>
                        <div className={"actions"}>
                          <SelectAutocomplete
                            value={selectedOption}
                            searchOption={"title"}
                            items={zendesk_options_title_map}
                            className={"select_secondary nodrag"}
                            onSelect={(e, type) => {
                              handleExtensions(e, type, i, el);
                            }}
                            placeholder={t(
                              "intents.config.accordion.params.zendesk_custom_field.custom_field"
                            )}
                            iteration={i}
                            t={t}
                          />
                          <Button
                            className={"btn_icon"}
                            type={"white"}
                            onClick={() => {
                              deleteTicketField(i);
                            }}
                            text={closeSvg()}
                          />
                        </div>
                      </div>
                    </div>
                    <>
                      {showZendeskTicketField && (
                        <>
                          <Button
                            disabled={isMaxReached}
                            type={"dashed"}
                            onClick={() => {
                              addParameterEquivalence(i);
                            }}
                            text={t(
                              "intents.config.accordion.params.zendesk_custom_field.add_button"
                            )}
                          />
                          {currentEquivalences?.map(
                            (equivalence, equivalenceIndex) => {
                              return (
                                <div
                                  className={
                                    "accordion__element_parameter_equivalence"
                                  }
                                  key={equivalenceIndex}
                                >
                                  <Input
                                    id={`equivalences-${equivalenceIndex}`}
                                    onChange={(e) => {
                                      updateParameterEquivalence(
                                        e,
                                        i,
                                        equivalenceIndex
                                      );
                                    }}
                                    value={equivalence.text}
                                    placeholder={t(
                                      "intents.config.accordion.params.zendesk_custom_field.text"
                                    )}
                                  />
                                  <SelectSimple
                                    valueSelected={
                                      equivalence.title
                                        ? equivalence.title
                                        : "-"
                                    }
                                    items={
                                      el.zendesk_ticket_field
                                        .custom_field_options_actual?.length
                                        ? el.zendesk_ticket_field
                                            .custom_field_options_actual
                                        : getDeskFieldByVariable(el.variable)
                                            ?.custom_field_options_actual || []
                                    }
                                    className={"select_secondary nodrag"}
                                    onSelect={(event) => {
                                      selectParameterEquivalence(event, {
                                        variableIndex: i,
                                        equivalenceIndex: equivalenceIndex,
                                      });
                                    }}
                                    placeholder={t(
                                      "intents.config.accordion.params.zendesk_custom_field.value"
                                    )}
                                    iteration={[i, equivalenceIndex]}
                                    t={t}
                                  />
                                  <div
                                    onClick={() => {
                                      deleteParameterEquivalence(
                                        i,
                                        equivalenceIndex
                                      );
                                    }}
                                    className={"delete_equivalence"}
                                  >
                                    {closeSvg()}
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </>
                      )}
                    </>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
